import React, { FunctionComponent } from 'react';
import { Box, Grid } from '@mui/material';
import { useSafeIntl } from 'bluesquare-components';
import InputComponent from '../../../../../../../../hat/assets/js/apps/Iaso/components/forms/InputComponent';
import { SearchButton } from '../../../../../../../../hat/assets/js/apps/Iaso/components/SearchButton';
import { useGetGroupDropdown } from '../../../../../../../../hat/assets/js/apps/Iaso/domains/orgUnits/hooks/requests/useGetGroups';
import { userHasPermission } from '../../../../../../../../hat/assets/js/apps/Iaso/domains/users/utils';
import { useFilterState } from '../../../../../../../../hat/assets/js/apps/Iaso/hooks/useFilterState';
import { useCurrentUser } from '../../../../../../../../hat/assets/js/apps/Iaso/utils/usersUtils';
import { appId } from '../../../../constants/app';
import MESSAGES from '../../../../constants/messages';
import { VACCINE_AUTH_ADMIN } from '../../../../constants/permissions';
import { baseUrls } from '../../../../constants/urls';
import { CreateAuthorisationModal } from '../Details/Modals/CreateEdit/CreateEditAuthorisationModal';
import { useStatusOptions } from '../hooks/statuses';
import { VaccineAuthParams } from '../types';

const baseUrl = baseUrls.nopv2Auth;
type Props = { params: VaccineAuthParams };

export const Nopv2AuthorisationsFilters: FunctionComponent<Props> = ({
    params,
}) => {
    const { formatMessage } = useSafeIntl();
    const { filters, handleSearch, handleChange, filtersUpdated } =
        useFilterState({ baseUrl, params });
    const { data: countryBlocksOptions, isFetching: isFetchingCountryBlocks } =
        useGetGroupDropdown({ blockOfCountries: 'true', appId });
    const statusOptions = useStatusOptions();
    const currentUser = useCurrentUser();

    return (
        <Grid container spacing={2}>
            <Grid item xs={6} md={4} lg={3}>
                <InputComponent
                    type="select"
                    multi
                    clearable
                    keyValue="block_country"
                    value={filters.block_country}
                    onChange={handleChange}
                    loading={isFetchingCountryBlocks}
                    options={countryBlocksOptions}
                    labelString={formatMessage(MESSAGES.countryBlock)}
                />
            </Grid>
            <Grid item xs={6} md={4} lg={3}>
                <InputComponent
                    type="select"
                    multi
                    clearable
                    keyValue="auth_status"
                    value={filters.auth_status}
                    onChange={handleChange}
                    options={statusOptions}
                    labelString={formatMessage(MESSAGES.status)}
                />
            </Grid>
            <Grid container item xs={12} md={4} lg={6}>
                <Box
                    display="flex"
                    justifyContent="flex-end"
                    alignItems="end"
                    flexDirection="column"
                    width="100%"
                >
                    <Box mt={2}>
                        <SearchButton
                            disabled={!filtersUpdated}
                            onSearch={handleSearch}
                        />
                    </Box>
                    {userHasPermission(VACCINE_AUTH_ADMIN, currentUser) && (
                        <Box mt={2} mb={2}>
                            <CreateAuthorisationModal
                                iconProps={{
                                    message: MESSAGES.addAuthorisation,
                                }}
                            />
                        </Box>
                    )}
                </Box>
            </Grid>
        </Grid>
    );
};
